import { css } from '@emotion/css'
import { borderRadius } from '../../styles'
import { getSkeletonColors } from '../../themes'

const styles = {
  field: css({
    borderRadius: borderRadius.default,
    height: 40,
    width: 240,
  }),
}

export default styles

export const fieldTheme = theme =>
  css({
    backgroundColor: getSkeletonColors(theme),
  })
